<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
      <!-- <input-select selectTitle="物资类目" :selectKey="'categoryCode'" :selectData="categoryTypeList" style="margin:0 20px" @search="search"/> -->
      </div>
    <div style="display: flex;justify-content: space-between">
      <!-- <input-search  placeholder="物资编号/物资名称"  @search="searchKey" /> -->
        <button-export
        :href="exportUrl"
        :beforeDownload="beforeDownload"
        v-if="permissionCodes.indexOf('036007001') !== -1"
        style="margin: 0 0 0 8px"
        download="download.xls"
        value="导出"/>
    </div>
    </div>
    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" :tableData="tableData" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination" :total="total" @toDetailsPage="toDetailsPage"></table-main>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Material";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "inventory-statistics",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "物资管理",
          name: "material-category-manage"
        },
        {
          value: "领用盘点报表"
        }
      ],
      fixTypeList: [],
      tableHead: [
        {
          prop: "taskName",
          label: "盘点任务"
        },
        {
          prop: "materialsName",
          label: "物资名称"
        },
        {
          prop: "applyNumber",
          label: "应盘数量"
        },
        {
          prop: "normalNumber",
          label: "正常数量"
        },
        {
          prop: "lostNumber",
          label: "遗失数量"
        },
        {
          prop: "abnormalNumber",
          label: "异常数量"
        },
        {
          prop: "scrapNumber",
          label: "报废数量"
        },
        {
          prop: "checkNumber",
          label: "数量核对"
        }
      ],
      tableData: [],
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1,
        categoryCode: ""
      },
      requestData2: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },
      total: 0,
      total2: 0,
      exportUrl: "",
      // operationArr: ["details"],
      dialogVisible: false,
      categoryTypeList: []
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
    this.getCategoryList();
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportCountReport}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&categoryCode=${this.requestData.categoryCode}`;
    },
    getCategoryList(searchKey) {
      this.$axios
        .post(api.getCategoryList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            list.map(v => {
              v.key = v.code;
              v.label = v.categoryName;
            });
            this.categoryTypeList = list;
            console.log(this.categoryTypeList);
            this.categoryTypeList.unshift({ key: "", label: "全部" });
          }
        })
        .catch(errorHandler("获取物资类目列表失败"));
    },
    getPage() {
      this.$axios
        .post(api.getCountReportPage, this.requestData)
        .then(res => {
          console.log(res);
          let list = res.data.data.list;
          list.map(v => {
            if (v.counted) {
              v.countedStatus = "已盘点";
            } else {
              v.countedStatus = "未盘点";
            }
            if (v.materialsStatus === "1") {
              v.materialsTextStatus = "正常";
            } else if (v.materialsStatus === "2") {
              v.materialsTextStatus = "遗失";
            } else if (v.materialsStatus === "3") {
              v.materialsTextStatus = "异常";
            } else if (v.materialsStatus === "4") {
              v.materialsTextStatus = "报废";
            } else {
              v.materialsTextStatus = "--";
            }
          });
          this.total = res.data.data.total;
          this.tableData = list;
        })
        .catch(errorHandler("获取分页失败"));
    },
    getPage2() {
      this.$axios
        .post(api.getCategoryStatistic, this.requestData2)
        .then(res => {
          this.tableData2 = res.data.data.list;
          this.total2 = res.data.data.total;
        })
        .catch(errorHandler("获取详情分页失败"));
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    deleteSelection() {},
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    confirm() {
      this.dialogVisible = false;
    },
    toDetailsPage(data) {
      this.requestData2 = {
        searchKey: "",
        pageSize: 10,
        pageNum: 1,
        categoryCode: data.categoryCode
      };
      this.getPage2();
      this.dialogVisible = true;
    },
    changePagination2(data) {
      this.requestData2.pageNum = data[0];
      this.requestData2.pageSize = data[1];
      // this.getQuestionList();
      this.getPage2();
    }
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/MaterialManagement/CollectingInventoryReport/CollectingInventoryReport.vue